import React, { useState, useEffect } from 'react';
import './ShortBreakPage.css';
import { supabase } from '../lib/supabase';
import ShortBreakInquiryModal from './ShortBreakInquiryModal';

const ShortBreakPage = () => {
    const [shortBreaks, setShortBreaks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedBreak, setSelectedBreak] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState({ text: '', type: '' });

    const showToast = (text, type) => {
        setToastMessage({ text, type });
        setTimeout(() => setToastMessage({ text: '', type: '' }), 3000);
    };

    useEffect(() => {
        fetchShortBreaks();
    }, []);

    const fetchShortBreaks = async () => {
        setLoading(true);
        const { data, error } = await supabase
            .from('short_breaks')
            .select('*')
            .eq('active', true)
            .order('display_order');

        if (!error && data) {
            setShortBreaks(data);
        }
        setLoading(false);
    };

    const handleInquire = (shortBreak) => {
        setSelectedBreak(shortBreak);
        setIsModalOpen(true);
    };

    return (
        <div className="shortbreak-page">
            {/* Hero Section */}
            <div className="shortbreak-hero">
                <div className="shortbreak-hero-overlay"></div>
                <div className="shortbreak-hero-content">
                    <h1 className="shortbreak-hero-title">
                        <i className="fa-solid fa-calendar-days"></i>
                        Short Break Packages
                    </h1>
                    <p className="shortbreak-hero-subtitle">
                        Quick getaways for the perfect weekend escape
                    </p>
                    <div className="shortbreak-hero-features">
                        <span><i className="fa-solid fa-clock"></i> 2-4 Days</span>
                        <span><i className="fa-solid fa-indian-rupee-sign"></i> Budget Friendly</span>
                        <span><i className="fa-solid fa-location-dot"></i> Nearby Destinations</span>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="shortbreak-container">
                <div className="shortbreak-intro">
                    <h2>Perfect Weekend Getaways</h2>
                    <p>
                        Escape the routine with our carefully curated short break packages. 
                        Perfect for weekends, long weekends, or quick refreshing trips.
                    </p>
                </div>

                {/* Loading State */}
                {loading ? (
                    <div className="shortbreak-loading">
                        <i className="fa-solid fa-spinner fa-spin"></i>
                        <p>Loading short breaks...</p>
                    </div>
                ) : shortBreaks.length === 0 ? (
                    <div className="shortbreak-empty">
                        <i className="fa-solid fa-calendar-xmark"></i>
                        <p>No short break packages available at the moment.</p>
                    </div>
                ) : (
                    <>
                        {/* Packages Grid */}
                        <div className="shortbreak-grid">
                            {shortBreaks.map((pkg) => (
                                <div key={pkg.id} className="shortbreak-card">
                                    <div className="shortbreak-card-image" style={{ backgroundImage: `url(${pkg.image_url})` }}>
                                        <div className="shortbreak-card-badge">{pkg.duration}</div>
                                    </div>
                                    <div className="shortbreak-card-content">
                                        <h3 className="shortbreak-card-title">{pkg.title}</h3>
                                        <div className="shortbreak-card-destination">
                                            <i className="fa-solid fa-location-dot"></i>
                                            {pkg.destination}
                                        </div>
                                        {pkg.description && (
                                            <p className="shortbreak-card-description">{pkg.description}</p>
                                        )}
                                        <ul className="shortbreak-card-highlights">
                                            {(pkg.highlights || []).slice(0, 4).map((highlight, i) => (
                                                <li key={i}>
                                                    <i className="fa-solid fa-circle-check"></i>
                                                    {highlight}
                                                </li>
                                            ))}
                                        </ul>
                                        <button 
                                            className="shortbreak-card-btn"
                                            onClick={() => handleInquire(pkg)}
                                        >
                                            <i className="fa-solid fa-paper-plane"></i>
                                            Inquire Now
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* CTA Section */}
                        <div className="shortbreak-cta">
                            <div className="shortbreak-cta-content">
                                <h2>Can't Find What You're Looking For?</h2>
                                <p>Let us create a custom short break package just for you</p>
                                <button 
                                    className="shortbreak-cta-btn"
                                    onClick={() => window.location.href = '/contact'}
                                >
                                    <i className="fa-solid fa-headset"></i>
                                    Contact Us
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <ShortBreakInquiryModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                shortBreak={selectedBreak}
                showToast={showToast}
            />

            {toastMessage.text && (
                <div className={`toast-notification toast-${toastMessage.type}`}>
                    <i className={`fa-solid ${toastMessage.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
                    {toastMessage.text}
                </div>
            )}
        </div>
    );
};

export default ShortBreakPage;
